export default "__VITE_ASSET__CccKZDfl__"